import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Sysse } from './Sysse-angular';

export const SysPriorityList = [{ id: "1", name: "最優先" }, { id: "2", name: "普通" }]; // 優先權
export const SysStyleList = [{ id: "B", name: "批次" }, { id: "R", name: "報表" }, { id: "A", name: "API批次" }]; // 工作類型
export const SysSe101List = [{ id: "H", name: "小時" }, { id: "D", name: "每日" }, { id: "W", name: "每週" }, { id: "M", name: "每月" }]; // 頻率類型
export const SysSe116List = [{ id: "", name: "不通知" }, { id: "1", name: "有錯誤通知" }, { id: "2", name: "有錯誤或警告通知" }, { id: "3", name: "完成就通知" }]; // MAIL通知方式

@Injectable({
  providedIn: 'root'
})
export class SysseServicePkg extends JkEntityV2 {
  SysPriorityList = SysPriorityList;
  SysStyleList = SysStyleList;
  SysSe101List = SysSe101List;
  SysSe116List = SysSe116List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Sysse();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      JOBID: '定時工作代號', OK: '結案碼', COMPANYID: '公司代號', USERID: '使用者代號', PROGID: '程式代號', PRIORITY: '優先權', DTREQUEST: '設定時間', STYLE: '工作類型', COMPUTER: '鎖定工作電腦', WEEK1: '週一', WEEK2: '週二', WEEK3: '週三', WEEK4: '週四', WEEK5: '週五', WEEK6: '週六', WEEK7: '週日', HHMM: '每日時分', PARAM1: '參數內容', SE100: '變動欄位', SE101: '頻率類型', SE102: '重複頻率', SE104: '時間範圍-起', SE105: '時間範圍-迄', SE106: '開始日期', SE107: '結束日期', SE108: '每月執行日', SE109: '下次日期', SE110: '下次時間', SE111: '計劃開始日期', SE112: '計劃開始時間', SE113: '備註', SE114: '變動欄位公式-起', SE115: '變動欄位公式-迄', SE116: 'MAIL通知方式', SE117: 'MAIL帳號', NAME1: '程式名稱'
    };

    this.fieldNames = 'JOBID,OK,COMPANYID,USERID,PROGID,PRIORITY,DTREQUEST,STYLE,COMPUTER,WEEK1,WEEK2,WEEK3,WEEK4,WEEK5,WEEK6,WEEK7,HHMM,PARAM1,SE100,SE101,SE102,SE104,SE105,SE106,SE107,SE108,SE109,SE110,SE111,SE112,SE113,SE114,SE115,SE116,SE117,NAME1';
    this.fieldLengths = { JOBID: 14, OK: 1, COMPANYID: 30, USERID: 10, PROGID: 20, PRIORITY: 2, DTREQUEST: 0, STYLE: 1, COMPUTER: 15, WEEK1: 1, WEEK2: 1, WEEK3: 1, WEEK4: 1, WEEK5: 1, WEEK6: 1, WEEK7: 1, HHMM: 4, PARAM1: 4000, SE100: 30, SE101: 1, SE102: 6, SE104: 4, SE105: 4, SE106: 8, SE107: 8, SE108: 8, SE109: 8, SE110: 4, SE111: 8, SE112: 4, SE113: 255, SE114: 255, SE115: 255, SE116: 1, SE117: 255, NAME1: 255 };
    this.columnDefs = [
      { field: "SE110", headerName: "下次時間", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "SE102", headerName: "重複頻率", headerTooltip: "", width: 118, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "SE103", headerName: "保留", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "SE104", headerName: "時間範圍-起", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "SE105", headerName: "時間範圍-迄", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "SE106", headerName: "開始日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "SE107", headerName: "結束日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "SE108", headerName: "每月執行日", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "SE109", headerName: "下次日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "SE101", headerName: "頻率類型", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.SysSe101List }, },
      { field: "SE111", headerName: "計劃開始日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "SE112", headerName: "計劃開始時間", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "SE113", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SE114", headerName: "變動欄位公式-起", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SE115", headerName: "變動欄位公式-迄", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SE116", headerName: "MAIL通知方式", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.SysSe116List }, },
      { field: "SE117", headerName: "MAIL帳號", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "NAME1", headerName: "程式名稱", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "JOBID", headerName: "定時工作代號", headerTooltip: "", width: 182, cellDataType: "text", },
      { field: "WEEK1", headerName: "週一", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "OK", headerName: "結案碼", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "COMPANYID", headerName: "公司代號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "USERID", headerName: "使用者代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "PROGID", headerName: "程式代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "PRIORITY", headerName: "優先權", headerTooltip: "", width: 86, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.SysPriorityList }, },
      { field: "DTREQUEST", headerName: "設定時間", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "STYLE", headerName: "工作類型", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.SysStyleList }, },
      { field: "COMPUTER", headerName: "鎖定工作電腦", headerTooltip: "", width: 190, cellDataType: "text", },
      { field: "SE100", headerName: "變動欄位", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "WEEK2", headerName: "週二", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WEEK3", headerName: "週三", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WEEK4", headerName: "週四", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WEEK5", headerName: "週五", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WEEK6", headerName: "週六", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WEEK7", headerName: "週日", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "HHMM", headerName: "每日時分", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "PARAM1", headerName: "參數內容", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSSE';
    this.isSys = true;
    this.sqlSelect = `SELECT SYSSE.*  FROM SYSSE`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY JOBID`;
    this.keyFields = ['JOBID'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['JOBID'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Sysse): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Sysse): Promise<Sysse> {
    await super.newRecord(newItem);
    return newItem;
  }




}

